import { ArsTableState, ArstActionSetAnalysisMethod } from "../interface";

/**
 * Refreshes reference metadata without marking the table body as edited.
 *
 * @param state - Current table state.
 * @param action - Method resolved from ARS context using the current body's method ID.
 * @returns Table state with the current analysis method.
 */
export const arst_setAnalysisMethod = <T>(
  state: ArsTableState<T>,
  action: ArstActionSetAnalysisMethod,
): ArsTableState<T> => ({ ...state, analysisMethod: action.analysisMethod });
